export default {
  activation_status: 'active',
  name: '',
  email: '',
  saas_role_id: '',
}
